import _ from 'lodash';
import React from 'react';
import autobind from 'autobind-decorator';

import Field from './field';

class Switch extends Field {
	renderInput () {
		const { fieldKey, dataId, formStore, store } = this.props;
		const { valueKey, label } = formStore.get(fieldKey);
		const value = this.getValue({ store, fieldKey, dataId, valueKey });

		return (
			<div className="grid-x align-middle">
				<div className="cell small-4 text-center">
					<span>Inactive</span>
				</div>

				<div className="cell shrink">
					<div className="switch margin-0">
						<input
							className="switch-input"
							id="exampleSwitch"
							type="checkbox"
							name="exampleSwitch"
							checked={ value === 'ACTIVE' }
							onChange={ this.handleChange } />

						<label className="switch-paddle" htmlFor="exampleSwitch">
							<span className="show-for-sr">{ label }</span>
						</label>
					</div>
				</div>

				<div className="cell small-4 text-center">
					<span>Active</span>
				</div>
			</div>
		);
	}

	@autobind
	handleChange ({ target }) {
		const { fieldKey, dataId, store } = this.props;
		const value = target.checked ? 'ACTIVE' : 'INACTIVE';

		if (_.isEmpty(dataId)) {

			store.set({ key: fieldKey, value });
		} else {

			const key = fieldKey.replace(/^\w+\./, '');
			store.items[store.getItemIndex({ id: dataId })][key] = value;
		}
	}
}

export default Switch;
